












































import {
    defineComponent,
    computed,
    onBeforeMount,
    ref,
} from '@vue/composition-api';

// hooks
import { useStore } from '@/store';

// primevue
import ProgressSpinner from 'primevue/progressspinner';

export default defineComponent({
    components: {
        ProgressSpinner,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        mapbox: {
            type: Object,
            default: () => {},
        },
    },
    setup(props: any) {
        // hooks
        const store = useStore();

        // store
        const isMeters = store.state.isMeters;

        // refs
        const showVertexes = ref(false);
        const vertexes = ref<any>([]);

        const unit = computed(() => {
            if (isMeters) {
                return 'm';
            } else {
                return 'yd';
            }
        });

        const area = computed(() => {
            if (props.geoRecord.geometry.coordinates.length && props.geoRecord.geometry.coordinates[0].length < 6) {
                toggleVertexesMeasurement();
            }

            if (typeof props.geoRecord.area == 'string') {
                return `Area: ${parseFloat(props.geoRecord.area)}${
                    unit.value
                }²`;
            }

            return `Area: ${
                Math.round(
                    props.geoRecord.area *
                        100 *
                        (isMeters ? 1 : 1.195990046301),
                ) / 100
            }${unit.value}²`;
        });

        const length = computed(() => {
            if (props.geoRecord.geometry.coordinates.length < 6) {
                toggleVertexesMeasurement();
            }

            if (typeof props.geoRecord.length == 'string') {
                return `Length: ${parseFloat(props.geoRecord.length)}${
                    unit.value
                }`;
            }

            return `Length: ${
                Math.round(
                    props.geoRecord.length * 100 * (isMeters ? 1 : 1.09361),
                ) / 100
            }${unit.value}`;
        });

        const perimeter = computed(() => {
            if (typeof props.geoRecord.perimeter == 'string') {
                return `Perimeter: ${parseFloat(props.geoRecord.perimeter)}${
                    unit.value
                }²`;
            }

            return `Perimeter: ${
                Math.round(
                    props.geoRecord.perimeter *
                        100 *
                        (isMeters ? 1 : 1.195990046301),
                ) / 100
            }${unit.value}`;
        });

        const toggleVertexesMeasurement = () => {
            showVertexes.value =
                props.geoRecord.vertexLabelState === 'on' ? true : false;
        };

        // life cycle
        onBeforeMount(() => {
            const source = props.mapbox.map.getSource(
                'geo-records-vertex-label',
            );
            let features = source._data.features;
            features = features.filter((feature: any) => {
                return feature.id === props.geoRecord.id;
            });
            features.forEach((element, index) => {
                vertexes.value.push({
                    id: index + 1,
                    title: element.properties.title,
                });
            });
        });

        return {
            unit,
            area,
            length,
            perimeter,
            vertexes,
            showVertexes,
        };
    },
});
